import { ISVGTextSettings } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import { memo } from 'react'
import TrashButton from '@/shared/Buttons/TrashButton'
import FormField from '@/shared/Forms/FormField'
import EquipmentDropdown from '@/pages/Equipment/components/Common/EquipmentDropdown'
import SvgChartSettingsCard from '@/pages/Dashboards/Charts/SVGChart/SvgChartSettingsSidePage/SvgChartSettingsCard'
import ParameterDropdown from '@/pages/Parameters/components/ParameterDropdown'
import { IOption } from '@/types/global.ts'
import SearchDropdownInput from '@/shared/Inputs/SearchDropdownInput'
import { IParameter } from '@/pages/Parameters/parameters.types'

interface IProps {
  settings: ISVGTextSettings
  onChange: (index: number, value: any, key: string, nestedKey: 'text') => void
  onDelete: (index: number, nestedKey: 'text') => void

  textNodeOptions: IOption<string>[]
  onNodeOptionHover: (id: string) => void

  index: number
}

const SvgChartSettingsTextRow = (props: IProps) => {
  return (
    <div className="flex-lines gap16">
      <div className="inline-flex-gap flex-space-between width100">
        <h5 className="text-heading-5">Узел {props.index + 1}</h5>
        <TrashButton onClick={() => props.onDelete(props.index, 'text')} />
      </div>
      <div className="inline-flex-gap gap16">
        <FormField label="ID узла" required={true} fullWidth={true}>
          <SearchDropdownInput
            options={props.textNodeOptions}
            selectedOption={props.settings.node_id as any}
            title="Выберите из списка"
            onSelect={(val, name) => props.onChange(props.index, val, name, 'text')}
            name="node_id"
            onOptionHover={props.onNodeOptionHover}
          />
        </FormField>
        <FormField label="Устройство" required={true} fullWidth={true}>
          <EquipmentDropdown
            value={props.settings.device_id}
            name="device_id"
            onChange={(val, name) => props.onChange(props.index, val, name, 'text')}
            placeholder="Выберите из списка"
          />
        </FormField>
      </div>
      <SvgChartSettingsCard>
        <div className="flex-lines gap12">
          <p className="text-caption" style={{ color: 'var(--text-description)' }}>
            Текст
          </p>
          <FormField label="Переменная">
            <ParameterDropdown
              value={props.settings.parameter_id as IParameter['id']}
              name="parameter_id"
              onChange={(val, name) => props.onChange(props.index, val, name, 'text')}
              placeholder="Выберите из списка"
            />
          </FormField>
        </div>
      </SvgChartSettingsCard>
    </div>
  )
}

export default memo(SvgChartSettingsTextRow)
